module.exports = __webpack_public_path__ + "assets/img/qr2.94e77b4a.png";